import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityWithLineItemsReference, EntityWithLineItemsType } from '../../../line-item-entry/models/invoice.interface';
import { InvoiceEventService } from '../../services/invoice-event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-invoice-dialog',
  templateUrl: './view-invoice.dialog.html',
  styleUrls: ['./view-invoice.dialog.scss']
})
export class ViewInvoiceDialogComponent implements OnInit, OnDestroy {
  emailOption: boolean;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewInvoiceDialogComponent, InvoiceDialogResult>,
    private invoiceEventService: InvoiceEventService,
    @Inject(MAT_DIALOG_DATA) public data: EntityWithLineItemsReference
  ) { }

  ngOnInit() {
    this.subscriptions.add(
      this.invoiceEventService.onEstimatePublished().subscribe(event => {
        this.onEstimatePublished(event.invoiceId);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onEstimatePublished(invoiceId: string) {
    this.dialogRef.close({refresh: true});

    const invoiceData = new EntityWithLineItemsReference();
    invoiceData.id = invoiceId;
    invoiceData.type = EntityWithLineItemsType.Invoice;

    return this.dialog.open<ViewInvoiceDialogComponent, EntityWithLineItemsReference>(ViewInvoiceDialogComponent, {
      disableClose: false,
      height: '90vh',
      width: '95vw',
      data: invoiceData,
      panelClass: 'invoice-panel'
    });
  }
}

export class InvoiceDialogResult {
  refresh = false;
}
